//External Dependencies
import React, { Component } from "react";
//Internal Dependencies
import AsyncComponent from "../../../components/async-component";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import PageContent from "../../../components/page-content";
import PageWrap from "../../../components/page-wrap";
import { SuppliersProvider } from "./context/SuppliersContext";

//Component
class Suppliers extends Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <SuppliersProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </SuppliersProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default Suppliers;